import { Button, CircularProgress, Grid, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Program } from "../model/program";
import { useEffect, useState } from "react";

interface OverviewProps {
    program: Program | null
    updateDescription: (programId: string, description: string) => void
}


export const Overview = ({program, updateDescription}: OverviewProps) => {
    const [programDescription, setProgramDescription] = useState<string | null>(program?.description || '');
    
    const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDescription = event.target.value;
        setProgramDescription(newDescription);
    };

    useEffect(() => {
        setProgramDescription(program?.description || '');
    }, [program]);

    // add debounce in ms
    useEffect(() => {
        const handler = setTimeout(() => {
            if (program && programDescription !== null && program.description != programDescription) {
                updateDescription(program.id, programDescription);
            }
            
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [programDescription]);

    return (
        <>
            <Grid item>
                <TextField
                    label="Program Description"
                    placeholder="Users of the program will see this description."
                    multiline
                    rows={4}
                    fullWidth
                    value={programDescription || ''}
                    onChange={handleDescriptionChange}
                    variant="outlined"
                    sx={{ margin: 2 }}
                />
            </Grid>
        </>
    )
}